import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { IconModule, SpinnerModule } from '@spartacus/storefront'
import { MaterialModule } from '../../shared/material.module'
import { SharedModule } from '../../shared/shared.module'
import { CustomPaymentTypeComponent } from './custom-payment-type.component'

@NgModule({
  declarations: [CustomPaymentTypeComponent],
  imports: [CommonModule, I18nModule, SpinnerModule, IconModule, MaterialModule, SharedModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutPaymentType: {
          component: CustomPaymentTypeComponent
        }
      }
    })
  ],
  exports: [CustomPaymentTypeComponent]
})
export class CustomPaymentTypeModule {}
